const orderSubscribers = new Set();
const driverStatusSubscribers = new Set();
const driverLocationSubscribers = new Set();
const orderCreatedSubscribers = new Set();

/** subscribeToMessages allows components to subscribe to message notifications.
 * When a new message is received,
 * all subscribed callbacks will be called with the message data.
 * * @param {Function} callback - The function to call when a new message is received.
 * @returns {Function} A function to unsubscribe from message notifications.
 */
export const subscribeToAllDriverLocation = (callback) => {
    driverLocationSubscribers.add(callback);
    return () => driverLocationSubscribers.delete(callback); // Unsubscribe
};

/** * notifyAllDriverLocation notifies all subscribers with the new message data.
 * This function is called when a new message is received from the WebSocket.
 * @param {Object} message - The message data to notify subscribers with.
 */
export const notifyAllDriverLocation = (message) => {
    for (const callback of driverLocationSubscribers) {
        callback(message);
    }
};

/** subscribeToAllDriverStatus allows components to subscribe to message notifications.
 * When a new message is received,
 * all subscribed callbacks will be called with the message data.
 * * @param {Function} callback - The function to call when a new message is received.
 * @returns {Function} A function to unsubscribe from message notifications.
 */
export const subscribeToAllDriverStatus = (callback) => {
    driverStatusSubscribers.add(callback);
    return () => driverStatusSubscribers.delete(callback); // Unsubscribe
};

/** * notifyAllDriverStatus notifies all subscribers with the new message data.
 * This function is called when a new message is received from the WebSocket.
 * @param {Object} message - The message data to notify subscribers with.
 */
export const notifyAllDriverStatus = (message) => {
    for (const callback of driverStatusSubscribers) {
        callback(message);
    }
};

/** subscribeToAllOrder allows components to subscribe to message notifications.
 * When a new message is received,
 * all subscribed callbacks will be called with the message data.
 * * @param {Function} callback - The function to call when a new message is received.
 * @returns {Function} A function to unsubscribe from message notifications.
 */
export const subscribeToAllOrder = (callback) => {
    orderSubscribers.add(callback);
    return () => orderSubscribers.delete(callback); // Unsubscribe
};

/** * notifyAllOrder notifies all subscribers with the new message data.
 * This function is called when a new message is received from the WebSocket.
 * @param {Object} message - The message data to notify subscribers with.
 */
export const notifyAllOrder = (message) => {
    for (const callback of orderSubscribers) {
        callback(message);
    }
};

/** subscribeToOrderCreated allows components to subscribe to message notifications.
 * When a new message is received,
 * all subscribed callbacks will be called with the message data.
 * * @param {Function} callback - The function to call when a new message is received.
 * @returns {Function} A function to unsubscribe from message notifications.
 */
export const subscribeToOrderCreated = (callback) => {
    orderCreatedSubscribers.add(callback);
    return () => orderCreatedSubscribers.delete(callback); // Unsubscribe
};

/** * notifyAllOrder notifies all subscribers with the new message data.
 * This function is called when a new message is received from the WebSocket.
 * @param {Object} message - The message data to notify subscribers with.
 */
export const notifyOrderCreated = (message) => {
    for (const callback of orderCreatedSubscribers) {
        callback(message);
    }
};

